var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 8.0829C76.1632 3.08119 86.8368 3.08119 95.5 8.0829L138.081 32.6671C146.744 37.6688 152.081 46.9124 152.081 56.9158V106.084C152.081 116.088 146.744 125.331 138.081 130.333L95.5 154.917C86.8368 159.919 76.1632 159.919 67.5 154.917L24.9189 130.333C16.2557 125.331 10.9189 116.088 10.9189 106.084V56.9158C10.9189 46.9124 16.2557 37.6688 24.9189 32.6671L67.5 8.0829Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13.3301C77.641 10.6506 83.359 10.6506 88 13.3301L135.787 40.9199C140.428 43.5994 143.287 48.5513 143.287 53.9103V109.09C143.287 114.449 140.428 119.401 135.787 122.08L88 149.67C83.359 152.349 77.641 152.349 73 149.67L25.2132 122.08C20.5721 119.401 17.7132 114.449 17.7132 109.09V53.9103C17.7132 48.5513 20.5721 43.5994 25.2132 40.9199L73 13.3301Z",
    fill: "url(#paint0_linear_100_8117)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16.7528C78.0222 14.4306 82.9778 14.4306 87 16.7528L133.323 43.4972C137.345 45.8195 139.823 50.1111 139.823 54.7556V108.244C139.823 112.889 137.345 117.181 133.323 119.503L87 146.247C82.9778 148.569 78.0222 148.569 74 146.247L27.6773 119.503C23.655 117.181 21.1773 112.889 21.1773 108.244V54.7556C21.1773 50.1111 23.655 45.8195 27.6773 43.4972L74 16.7528Z",
    fill: "url(#paint1_linear_100_8117)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.168 52.8322C106.296 48.9705 101.052 46.8018 95.5837 46.8018C90.1157 46.8018 84.871 48.9705 80.9998 52.8322L79.055 54.7765C78.7996 55.0318 78.597 55.3349 78.4587 55.6686C78.3204 56.0023 78.2493 56.3599 78.2492 56.7211C78.2492 57.0822 78.3203 57.4399 78.4585 57.7735C78.5967 58.1072 78.7993 58.4104 79.0546 58.6658L82.943 62.5541C83.4586 63.0697 84.158 63.3594 84.8873 63.3595C85.6165 63.3595 86.3159 63.0699 86.8317 62.5544L88.7772 60.6096C90.5824 58.8046 93.0307 57.7907 95.5835 57.7908C98.1363 57.7909 100.585 58.805 102.39 60.6101C104.195 62.4152 105.209 64.8634 105.209 67.4162C105.209 69.9691 104.195 72.4174 102.39 74.2226L92.6658 83.9442C90.9621 85.6289 88.6944 86.6224 86.3009 86.7325C83.9073 86.8426 81.558 86.0616 79.7068 84.5404L77.5964 82.7778C77.3192 82.5463 76.9991 82.3716 76.6543 82.2638C76.3096 82.1559 75.9469 82.1171 75.5872 82.1495C75.2274 82.1818 74.8776 82.2847 74.5576 82.4524C74.2376 82.62 73.9538 82.849 73.7223 83.1263L70.1978 87.349C69.7305 87.909 69.5047 88.6317 69.5702 89.3581C69.6357 90.0846 69.987 90.7552 70.5469 91.2226L72.6573 92.9838C76.6002 96.3036 81.6486 98.0171 86.7976 97.7832C91.9467 97.5493 96.819 95.3852 100.445 91.7216L110.169 81.9999C114.036 78.1318 116.209 72.8857 116.209 67.4158C116.208 61.9459 114.035 56.7 110.168 52.8322Z",
    fill: "url(#paint2_linear_100_8117)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0568 101.446C78.5412 100.93 77.8418 100.64 77.1126 100.64C76.3833 100.64 75.6839 100.93 75.1681 101.445L73.2227 103.39C71.4174 105.195 68.9691 106.209 66.4163 106.209C63.8635 106.209 61.4153 105.195 59.6102 103.39C57.8051 101.585 56.7909 99.1364 56.7908 96.5836C56.7907 94.0308 57.8046 91.5825 59.6096 89.7773L69.334 80.0557C71.037 78.3697 73.3049 77.3754 75.6989 77.2653C78.0928 77.1552 80.4424 77.937 82.2931 79.4595L84.4034 81.222C84.6806 81.4536 85.0008 81.6283 85.3455 81.7361C85.6903 81.8439 86.0529 81.8828 86.4126 81.8504C86.7724 81.8181 87.1223 81.7151 87.4422 81.5475C87.7622 81.3799 88.046 81.1509 88.2775 80.8736L91.802 76.6508C92.2693 76.0908 92.4951 75.3681 92.4296 74.6417C92.3641 73.9153 92.0127 73.2446 91.4527 72.7773L89.3424 71.0161C85.3996 67.696 80.3512 65.9824 75.202 66.2163C70.0529 66.4502 65.1806 68.6145 61.555 72.2783L51.8309 81.9999C47.963 85.868 45.7902 91.1141 45.7903 96.5843C45.7904 102.054 47.9635 107.3 51.8316 111.168C55.6996 115.036 60.9458 117.209 66.4159 117.209C71.8861 117.209 77.1321 115.036 81 111.168L82.9448 109.223C83.2002 108.968 83.4029 108.665 83.5411 108.331C83.6794 107.998 83.7505 107.64 83.7506 107.279C83.7506 106.918 83.6795 106.56 83.5413 106.226C83.4031 105.893 83.2005 105.589 82.9452 105.334L79.0568 101.446Z",
    fill: "url(#paint3_linear_100_8117)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_100_8117",
    x1: 80.5,
    y1: 9,
    x2: 80.5,
    y2: 154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_100_8117",
    x1: 80.5,
    y1: 13,
    x2: 80.5,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_100_8117",
    x1: 92.8839,
    y1: 46.8018,
    x2: 92.8839,
    y2: 97.8044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_100_8117",
    x1: 69.1155,
    y1: 66.1951,
    x2: 69.1155,
    y2: 117.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/invite_icon.6887c582e8454133bb4718b2611fbc43.svg";
export { ForwardRef as ReactComponent };